import { SET_CURRENT_SUBSECTION_ID, SET_SECTIONS_COLLAPSED, SET_COLLAPSE_SECTIONS_LANGS, } from './constants';
const INITIAL_STATE = {
    currentSubSectionId: null,
    sectionsCollapsed: [],
    collapsedSectionsLangs: null,
};
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_SUBSECTION_ID:
            return { ...state, currentSubSectionId: action.payload };
        case SET_SECTIONS_COLLAPSED:
            return { ...state, sectionsCollapsed: action.payload };
        case SET_COLLAPSE_SECTIONS_LANGS:
            return { ...state, collapsedSectionsLangs: action.payload };
        default:
            return state;
    }
};
export default reducer;
